import { Button, ButtonGroup } from "@blueprintjs/core";
import { IconNames } from "@blueprintjs/icons";
import autobind from "autobind-decorator";
import { IFieldProps } from 'decorator-form';
import React from "react";

import CssUnitWidget from "common/form/widgets/CssUnitWidget";
import NumberWidget from "common/form/widgets/NumberWidget";

export interface IBreakpoint {
	width: string;
	columns: number;
}

export class BreakpointsField extends React.PureComponent<IFieldProps<IBreakpoint[]>> {


	public render() {
		const data = this.props.formData || [];
		const breakpoints = data.map((bp, i) => (
			<div key={i}>
				<CssUnitWidget
					value={bp.width}
					onChange={(v) => this.editBreakpoint(i, {...bp, width: v})}
					readonly={false}
					autofocus={false}
					options={undefined}
					label="Breakpoint"
				/>
				<NumberWidget
					value={bp.columns}
					onChange={(v) => {
							if (v > 0 && v < 20) {	// probably should be a reasonable amount of columns
								this.editBreakpoint(i, {...bp, columns: v});
							}
						}
					}
					readonly={false}
					autofocus={false}
					options={undefined}
					label="Columns"
				/>
				<ButtonGroup minimal={true}>
					<Button
						icon={IconNames.MINUS}
						small={true}
						onClick={() => this.removeBreakpoint(i)}
					/>
				</ButtonGroup>
			</div>
		));

		return (
			<div>
				{breakpoints}
				<Button
					icon={IconNames.ADD}
					onClick={this.addBreakpoint}
					text="Add Breakpoint"
				/>
			</div>
		);
	}

	// append a new breakpoint
	@autobind
	private addBreakpoint() {
		const data = this.props.formData || [];
		const nextData = [...data, {width: "768px", columns: 3}];
		this.props.onChange(nextData);
	}

	// remove a breakpoint by index
	@autobind
	private removeBreakpoint(index: number) {
		this.props.onChange(this.props.formData.filter((bp, i) => i !== index));
	}

	// edit a breakpoint by index
	@autobind
	private editBreakpoint(index: number, value: IBreakpoint) {
		this.props.onChange(this.props.formData.map((bp, i) => i === index ? value : bp));
	}
}



// WEBPACK FOOTER //
// ./src/common/form/fields/BreakpointsField.tsx